import { guardedCustomElement } from '../utils/guarded-custom-element';
import { SDSIconComponent } from './sds-icon.component';

@guardedCustomElement('sds-icon')
export class SDSIcon extends SDSIconComponent {}

declare global {
	interface HTMLElementTagNameMap {
		'sds-icon': SDSIcon;
	}
}
